export default __webpack_public_path__ + "images/75f861e399e59623485a6233a2436ab4-finance.webp";